const ORIGIN = "https://roadtrip-planner-ih.herokuapp.com/api"
// const ORIGIN = "http://localhost:3003/api"

export { ORIGIN }